export default "__VITE_ASSET__srUvmciT__"